import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const OfferingCard = ({ item, i, ctaLabel, ctaHref, tone, prefix }) => {
  const Icon = item.icon;
  const dark = tone === "dark";
  return (
    <Reveal delay={(i % 3) * 0.08} className="h-full">
      <article
        className={`group relative flex h-full flex-col p-7 transition-colors duration-500 sm:p-9 ${dark ? "hover:bg-plum/40" : "hover:bg-white"}`}
        data-testid={`${prefix}-card-${slug(item.title)}`}
      >
        <span aria-hidden="true" className="absolute left-0 top-0 h-px w-0 bg-gold transition-[width] duration-700 group-hover:w-full" />
        <div className="flex items-start justify-between">
          <span className={`font-mono text-xs ${dark ? "text-gold/80" : "text-plum-2"}`}>{String(i + 1).padStart(2, "0")}</span>
          <Icon className={`h-6 w-6 transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-110 ${dark ? "text-gold-light" : "text-plum-2"}`} strokeWidth={1.4} aria-hidden="true" />
        </div>
        <h3 className={`mt-10 font-display text-2xl font-normal leading-tight tracking-tight sm:text-[1.7rem] ${dark ? "text-white" : "text-ink"}`}>{item.title}</h3>
        <p className={`mt-4 flex-1 text-[15px] leading-relaxed ${dark ? "text-white/70" : "text-ink/70"}`}>{item.description}</p>
        <Link
          to={ctaHref(item)}
          data-testid={`${prefix}-cta-${slug(item.title)}`}
          className={`mt-8 inline-flex min-h-[44px] items-center gap-2 self-start text-[12px] font-semibold uppercase tracking-[0.16em] ${dark ? "text-gold-light" : "text-plum"}`}
        >
          {ctaLabel}
          <ArrowRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1.5" aria-hidden="true" />
        </Link>
      </article>
    </Reveal>
  );
};

export const OfferingGrid = ({ items, ctaLabel = "Learn More", ctaHref, tone = "dark", prefix = "offering" }) => (
  <div
    className={`grid grid-cols-1 border-l border-t md:grid-cols-2 lg:grid-cols-3 [&>*]:border-b [&>*]:border-r ${
      tone === "dark" ? "border-white/10 [&>*]:border-white/10" : "border-ink/10 [&>*]:border-ink/10"
    }`}
    data-testid={`${prefix}-grid`}
  >
    {items.map((item, i) => (
      <OfferingCard key={item.title} item={item} i={i} ctaLabel={ctaLabel} ctaHref={ctaHref} tone={tone} prefix={prefix} />
    ))}
  </div>
);
